<div class="lg:px-6 px-2 py-5">
  <div class="surface-card p-4 md:p-5 shadow-2 border-round-2xl">
    <div class="flex flex-wrap gap-3">
      <button
        *ngIf="userRole?.name !== 'portalmanagement_user'"
        type="button"
        pButton
        icon="pi pi-sync"
        label="Swop Device"
        [loading]="loadingDeviceSwop"
        (click)="showDeviceSwopDialog(customerCircuit, $event)"
        class="w-full md:w-auto"
      ></button>
    </div>
  </div>
</div>
